export default {"src":"/pro/_next/static/media/ada.a17d3f25.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};